import React from "react";
import { Card, Modal } from "react-bootstrap";
import DirectImageUpload from "./DirectImageUpload";

const UpdateBanner = ({ projectDetails, callBack }) => {

    return (
        <Card
            className="pb-3"
            id="formHandler"
            style={{ height: "auto" }}
            show={true}
        >
            <Card.Header>
                <div className="d-flex align-items-center justify-content-between w-100">
                    <h5 className="text-primary fw-semibold project-title">
                        Project Images
                    </h5>
                </div>
            </Card.Header>
            <Card.Body>
                <DirectImageUpload
                    fieldName="bannerImage"
                    label="Banner Image (16:9 Ratio)"
                    projectDetails={projectDetails}
                    imageRatio="16_9"
                    callBack={callBack}
                />
                <DirectImageUpload
                    fieldName="squareImage"
                    label="Square Image (1:1 Ratio)"
                    projectDetails={projectDetails}
                    imageRatio="1_1"
                    callBack={callBack}
                />
            </Card.Body>
        </Card>
    );
};

export default UpdateBanner;
